import React from "react";
import { Box, Paper, Typography, styled } from "@mui/material";
import {
  formattedAmount,
  formattedAmountWithoutAed,
} from "../../../../utils/CommonFunction";
import { ReactComponent as BlackSmallDhiramIcon } from "../../../../assets/svg/BlackSmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

const StyledTypography = styled(Typography)(({ theme }) => ({
  borderBottom: "none",
  display: "flex",
  alignItems: "center",
  fontSize: "18px",
  color: "#0D0D0E",
  fontWeight: 500,
  gap: "10px",
}));

const ProjectStats = ({ summary, isMobile }) => {
  const progressColors = {
    paid: "#4BB34B",
    due: "#C3C6D6",
    notDue: "#FF971C",
  };

  const calculateSegmentWidth = (value) => {
    if (summary?.totalCost <= 0 || !value) return 0;
    return (value / summary?.totalCost) * 100;
  };

  const paidWidth = calculateSegmentWidth(summary?.totalPaidAmount);
  const dueWidth = calculateSegmentWidth(summary?.totalNotDueAmount);
  const notDueWidth = calculateSegmentWidth(summary?.totalDueAmount);

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      width="100%"
      padding="0"
      marginTop="2vh"
    >
      <Box width="100%">
        <Paper
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "flex-start",
            boxShadow: "none",
            borderRadius: 0,
            padding: isMobile ? "2vh 1vw" : "1vh .5vw",
            gap: isMobile ? "20px" : "0",
            flexWrap: "wrap",
          }}
        >
          <div style={{
            paddingRight: isMobile ? "0" : "2vw",
            minWidth: isMobile ? "100%" : "200px",
            flex: isMobile ? "1" : "0 0 auto"
          }}>
            <Typography
              sx={{
                mb: 1,
                letterSpacing: 0,
                fontSize: "14px",
                color: "#949DAA",
                fontWeight: "500",
              }}
            >
              Total Project Cost
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? "20px" : "24px",
                color: "#0D0D0E",
                fontWeight: 500,
              }}
            >
              {formattedAmount(summary?.totalCost) || "---"}
            </Typography>
          </div>
          <div style={{
            borderLeft: !isMobile && "1px solid #D7D8D9",
            minWidth: isMobile ? "100%" : "300px"
          }}>
            <div
              style={{
                width: "100%",
                padding: isMobile ? "0" : "0 2vw",
                display: "flex",
                flexDirection: "row",
                alignItems: isMobile ? "flex-start" : "center",
                gap: isMobile ? "25px" : "70px",
                flexWrap: "wrap",
              }}
            >
              <div >
                <Typography
                  sx={{
                    mb: 1,
                    letterSpacing: 0,
                    fontSize: "14px",
                    color: "#949DAA",
                    fontWeight: "500",
                  }}
                >
                  Paid
                </Typography>
                <StyledTypography>
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: progressColors.paid,
                    }}
                  ></div>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2px",
                      fontSize: isMobile && "14px",
                    }}
                  >
                    {renderCurrencyIcon('black-small')}
                    {formattedAmountWithoutAed(summary?.totalPaidAmount) ||
                      "---"}
                  </span>
                </StyledTypography>
              </div>
              <div >
                <Typography
                  sx={{
                    mb: 1,
                    letterSpacing: 0,
                    fontSize: "14px",
                    color: "#949DAA",
                    fontWeight: "500",
                  }}
                >
                  Due
                </Typography>
                <StyledTypography>
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: progressColors.notDue,
                    }}
                  ></div>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2px",
                      fontSize: isMobile && "14px",
                    }}
                  >
                    {renderCurrencyIcon('black-small')}
                    {formattedAmountWithoutAed(summary?.totalDueAmount) ||
                      "---"}
                  </span>
                </StyledTypography>
              </div>
              <div >
                <Typography
                  sx={{
                    mb: 1,
                    letterSpacing: 0,
                    fontSize: "14px",
                    color: "#949DAA",
                    fontWeight: "500",
                  }}
                >
                  Not Due
                </Typography>
                <StyledTypography>
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: progressColors.due,
                    }}
                  ></div>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2px",
                      fontSize: isMobile && "14px",
                    }}
                  >
                    {renderCurrencyIcon('black-small')}
                    {formattedAmountWithoutAed(summary?.totalNotDueAmount) ||
                      "---"}
                  </span>
                </StyledTypography>
              </div>
            </div>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                height: 10,
                borderRadius: 5,
                backgroundColor: "transparent",
                overflow: "hidden",
                mt: 1,
                marginLeft: isMobile ? "0" : "2vw",
              }}
            >
              <Box
                sx={{
                  width: `${paidWidth}%`,
                  backgroundColor: progressColors.paid,
                  borderRadius: "5px",
                }}
              />
              <Box
                sx={{
                  width: `${notDueWidth}%`,
                  backgroundColor: progressColors.notDue,
                  borderRadius: "5px",
                }}
              />
              <Box
                sx={{
                  width: `${dueWidth}%`,
                  backgroundColor: progressColors.due,
                  borderRadius: "5px",
                }}
              />
            </Box>
          </div>
        </Paper>
      </Box>
    </Box>
  );
};

export default ProjectStats;
